/**
 * Os anexos prontos do composer no vocabulário do SERVIDOR.
 *
 * ★ [#28] Existe para os DOIS modos falarem a mesma língua. O Modo Chat já
 * convertia `{uploadId, nome, contentType, tamanho}` → `{upload_id, nome,
 * content_type, tamanho}` dentro de `_buildChatBody`; o Modo Agente não
 * convertia nada porque nunca chegou a receber anexo nenhum.
 *
 * Medido em produção (19/09/2026, escritório 83, cliente Silvana 125759): o
 * upload do extrato funcionava (`uploadId: fa7ea794-…`, status `enviado`), o
 * envio saía, e a IA respondia *"Não recebi nenhum arquivo anexado nesta
 * conversa"*. O `POST /runs` aceita `anexos` e o backend os repassa
 * (`aceitar_run.py`); o que faltava era o front os PASSAR.
 *
 * Duas grafias do mesmo fato é como a segunda diverge da primeira — por isso
 * uma função só, e os dois caminhos a chamam.
 *
 * @param {Array=} anexos `anexosProntos` do composer.
 * @returns {Array} `[]` quando não há nada a mandar (o chamador omite a chave).
 */
export function anexosParaOCorpo(anexos) {
  if (!Array.isArray(anexos) || !anexos.length) return []
  return anexos.map(function(anexo) {
    return {
      upload_id: anexo.uploadId,
      nome: anexo.nome,
      content_type: anexo.contentType,
      tamanho: anexo.tamanho,
    }
  })
}

export default { anexosParaOCorpo }
